module.exports = __webpack_public_path__ + "static/media/menu-boczne-zglos-blad_BLUE.06c4e08e.svg";